const dir = "ltr";

module.exports = dir;
